import {
  createWorkflowWebhook,
  fetchWorkflowWebhooks,
  updateWorkflowWebhook,
  deleteWorkflowWebhook,
} from 'api/WorkflowWebhooksAPI';
import { call, put, takeLatest } from 'redux-saga/effects';
import { push } from 'redux-first-history';
import { getErrorResponse } from 'utils/xhr';
import { addPositiveToast, addNegativeToast } from 'modules/toastContainer';
import { addToRootSaga } from 'store';
import * as actions from './actions';
import * as actionTypes from './actionTypes';
import { transformWorkflowWebhookInput } from './utils';

/**
 * fetchWorkflowWebhooksSaga
 * Saga for fetching journey webhooks
 * @return { void }
 */
export function* fetchWorkflowWebhooksSaga() {
  try {
    const response = yield call(fetchWorkflowWebhooks);
    yield put(actions.fetchWorkflowWebhooksResponse(response.data));
  } catch (error) {
    const err = getErrorResponse(error);
    yield put(actions.fetchWorkflowWebhooksError(err));
    const message = `Error fetching journey webhooks. ${err}`;
    yield put(addNegativeToast(message));
  }
}

export function* updateWorkflowWebhookSaga({ payload: { workflowWebhook, onSave } }) {
  try {
    const response = yield call(
      updateWorkflowWebhook,
      transformWorkflowWebhookInput(workflowWebhook),
    );
    yield put(actions.updateWorkflowWebhookResponse(response.data));
    yield put(addPositiveToast(`${workflowWebhook.name} successfully updated`));
    onSave();
  } catch (error) {
    const err = getErrorResponse(error);
    yield put(actions.updateWorkflowWebhookError(err));
    const message = `Error saving journey webhook. ${err}`;
    yield put(addNegativeToast(message));
  }
}

export function* createWorkflowWebhookSaga({ payload: { workflowWebhook } }) {
  try {
    const {
      data: { id },
    } = yield call(createWorkflowWebhook, transformWorkflowWebhookInput(workflowWebhook));
    yield put(push(`/workflows/webhooks/${id}`));
  } catch (error) {
    const err = getErrorResponse(error);
    yield put(actions.createWorkflowWebhookError(err));
    yield put(addNegativeToast(`Error creating journey webhook. ${err}`));
  }
}

export function* deleteWorkflowWebhookSaga({ payload: { workflowWebhook, onDelete } }) {
  try {
    yield call(deleteWorkflowWebhook, workflowWebhook.id);
    yield put(addPositiveToast(`${workflowWebhook.name} successfully deleted`));
    onDelete(workflowWebhook.id);
  } catch (error) {
    yield put(actions.deleteWorkflowWebhookError(getErrorResponse(error)));
    yield put(addNegativeToast('Unable to delete journey webhook. Please try again.'));
  }
}

addToRootSaga([takeLatest(actionTypes.FETCH_WORKFLOW_WEBHOOKS_REQUEST, fetchWorkflowWebhooksSaga)]);
addToRootSaga([takeLatest(actionTypes.UPDATE_WORKFLOW_WEBHOOK_REQUEST, updateWorkflowWebhookSaga)]);
addToRootSaga([takeLatest(actionTypes.CREATE_WORKFLOW_WEBHOOK_REQUEST, createWorkflowWebhookSaga)]);
addToRootSaga([takeLatest(actionTypes.DELETE_WORKFLOW_WEBHOOK_REQUEST, deleteWorkflowWebhookSaga)]);
